// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__v-RTp","upload":"Small_upload__2b-Ng","imageWrap":"Small_imageWrap__39zbw","removeBtn":"Small_removeBtn__12uet"};